import type { ReactElement } from "react"

interface DropdownDatalistProps {
  id: string
  options: readonly string[]
}

export function DropdownDatalist({
  id,
  options,
}: DropdownDatalistProps): ReactElement {
  return (
    <datalist id={id}>
      {options.map((option) => (
        <option key={option} value={option} />
      ))}
    </datalist>
  )
}
